import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    Input,
    Optional,
    Output
} from "@angular/core";
import {FUIAbstractControl} from "../framework/abstract-control";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIFormContext} from "../../form-context/form-context";
import {FUIOptionsService} from "../framework/options.service";
import {FUIAbstractSelectInput} from "./inputs/abstract-select-input";
import {FUISelectAction} from "../select-action";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUISelectControlComponent),
            multi: true
        },
        FUIOptionsService
    ],
    selector: "fui-select-control",
    templateUrl: "./select-control.component.html",
    standalone: false
})
export class FUISelectControlComponent extends FUIAbstractControl {
    @Input() public internallyFilterable: boolean;
    @Output() public filtered$: EventEmitter<string>;
    @Input() public labelField: string;
    @Output() public select$: EventEmitter<any>;
    @Input() public allowDirectInput: boolean = false;
    @Input() public isNumeric: boolean = false;
    @Input() public total: number;
    @Input() public valueField: string;
    @Input() public optionElementHandler: (option: any, elementRef: ElementRef) => void;

    /**
     * Optional additional action buttons
     */
    @Input() public actions: FUISelectAction[];

    /**
     * Indicates if the select control can be removed when in pill mode
     */
    @Input() public removable: boolean = true;

    /**
     * Defines the label for the option to clear the selection
     */
    @Input() public clearSelectionOptionLabel: string;
    @Input() public allowClearSelectionOption: boolean = true;

    /**
     * Emitted when an action is clicked
     */
    @Output() public action$: EventEmitter<FUISelectAction>;

    private _options: Array<any>;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
        this.internallyFilterable = true;
        this.filtered$ = new EventEmitter<string>();
        this.select$ = new EventEmitter<any>();
        this.action$ = new EventEmitter<FUISelectAction>();
    }

    /**
     *
     * @returns {Array<any>}
     */
    get options(): Array<any> {
        return this._options;
    }

    /**
     *
     * @param {Array<any>} options
     */
    @Input()
    set options(options: Array<any>) {
        this._options = options;
    }

    public close(): void {
        (<FUIAbstractSelectInput> this.input).popped = false;
    }

    public open(): void {
        (<FUIAbstractSelectInput> this.input).popped = true;
    }
}
